import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "page-cover_word flex-column flex-wrap cursor-pointer",
  style: {"max-width":"100%"}
}
const _hoisted_2 = { class: "phonetic" }
const _hoisted_3 = { class: "translate" }
const _hoisted_4 = { class: "mb-3" }

import { IonButton, popoverController } from "@ionic/vue";
import http from "@/js/http";
import store from "@/js/store";
import { onBeforeUnmount, onMounted, ref, watch } from "vue";
import { openMsgToast } from "@/views/AIGenerate/openModal";
import { useStorage } from "@vueuse/core/index";
import getOssPlayInstance from "@/js/ossPlay";


export default /*@__PURE__*/_defineComponent({
  __name: 'GrammarPopover',
  props: ["sentence", "gptStr", "word"],
  setup(__props) {

/* disabled-eslint */
const props = __props;
const audioPlayer = ref();
const mediaType = ref();
const aiTheme = useStorage("ai-theme", "brown", localStorage);
const bofangIcon = ref("icon-bofang3");
const timer = ref(0);
const transList = ref([]);
const phoneticObj = ref({});
const audioInstance = ref({ progress: 0 });

watch(
  () => audioInstance.value.progress,
  () => {
    bofangIcon.value = `icon-bofang${1 + (Math.trunc(audioInstance.value.progress / 18) % 3)}`;
    if (audioInstance.value.progress === 100) {
      bofangIcon.value = "icon-bofang3";
    }
  },
  { deep: true }
);

//查询阅读理解文章
function queryReadingWord() {
  http.get("/readingVocabulary/getReadingWordDetail?word=" + props.sentence).then((res) => {
    if (res.data.success) {
      transList.value = res.data.list;
      const usPhonetic = res.data.dataMap?.["us"]
        ? res.data.dataMap["us"]
            .split(", ")
            .map((i: any) => `/${i.trim()}/`)
            .join(" ")
        : "";
      const ukPhonetic = res.data.dataMap?.["uk"]
        ? res.data.dataMap["uk"]
            .split(",")
            .map((i: any) => `/${i.trim()}/`)
            .join(" ")
        : "";
      phoneticObj.value = { us: usPhonetic, uk: ukPhonetic };
    }
  });
}

async function putIntoGlossary() {
  const appointment = store.getAppointment();
  const params = {
    aptmId: appointment.aptmId,
    courseId: appointment.courseId,
    word: props.sentence.trim(),
    courseType: appointment.courseType,
  };

  http.post("/readingVocabulary/addReadingWordToPersonal", params).then(async (res) => {
    if (res.data.success) {
      let data = res.data.data;
      if (data?.vocabularyId) {
        const appointment = store.getAppointment();
        const params = {
          list: [
            {
              studentId: appointment.studentId,
              vocabularyId: data.vocabularyId,
              mastery: 1,
              selected: 2,
            },
          ],
          studentId: appointment.studentId,
          aptmId: appointment.aptmId,
          total: 1,
          yesNum: 0,
          notNum: 0,
          courseId: appointment.courseId,
        };
        http.post("/vocabulary/beginReviewClassAndUpdateMastery", params).catch((err) => {
          console.log(err);
        });
      }
      popoverController.dismiss({ status: "关闭popover" }).catch((e) => console.log(e));
      await openMsgToast(res.data.messageExtra);
    } else {
      await openMsgToast("加入生词本失败");
    }
  });
}

function audioStop() {
  audioInstance.value.stop();
}

function audioPlay() {
  audioInstance.value = getOssPlayInstance().init({ msg: props.word });
  audioInstance.value.play();
}

onBeforeUnmount(() => {
  audioStop();
});
onMounted(() => {
  // 初始化 Audio 播放器
  /* eslint-disable */
  // audioPlayer.value = new AudioPlayer("/assets/js");
  queryReadingWord()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["page-cover flex-row justify-center word-popover", _unref(aiTheme)]),
    style: {"max-width":"100%"}
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", null, [
        _createElementVNode("span", null, _toDisplayString(props.sentence), 1),
        _createElementVNode("span", null, [
          _createElementVNode("i", {
            id: "ai-sentence-audio",
            class: _normalizeClass(["iconfont", bofangIcon.value]),
            style: {"color":"#2bca9c","margin-left":"2vw","vertical-align":"middle"},
            onClick: audioPlay
          }, null, 2)
        ])
      ]),
      _createElementVNode("p", _hoisted_2, _toDisplayString(phoneticObj.value["us"]) + " " + _toDisplayString(phoneticObj.value["uk"]), 1),
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transList.value, (paraphrase, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: "translate-content"
          }, _toDisplayString(paraphrase), 1))
        }), 128))
      ]),
      _createElementVNode("p", _hoisted_4, _toDisplayString(props.gptStr), 1),
      _createVNode(_unref(IonButton), {
        class: "page-cover_word-button",
        shape: "round",
        onClick: putIntoGlossary
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("加入生词本 ")
        ])),
        _: 1,
        __: [0]
      })
    ])
  ], 2))
}
}

})